import { render, staticRenderFns } from "./XkContainer.vue?vue&type=template&id=e03ddd36&scoped=true&"
import script from "./XkContainer.vue?vue&type=script&lang=js&"
export * from "./XkContainer.vue?vue&type=script&lang=js&"
import style0 from "./XkContainer.vue?vue&type=style&index=0&id=e03ddd36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03ddd36",
  null
  
)

export default component.exports